import { Language } from "@finbackoffice/enums";

export function resolveLocale(language: Language) {
    switch (language) {
        case Language.ko:
            return import("date-fns/locale/ko").then((module) => module.ko);
        case Language.fr:
            return import("date-fns/locale/fr").then((module) => module.fr);
        case Language.de:
            return import("date-fns/locale/de").then((module) => module.de);
        case Language.es:
            return import("date-fns/locale/es").then((module) => module.es);
        case Language.pt:
            return import("date-fns/locale/pt").then((module) => module.pt);
        case Language.ru:
            return import("date-fns/locale/ru").then((module) => module.ru);
        case Language.ja:
            return import("date-fns/locale/ja").then((module) => module.ja);
        case Language.tr:
            return import("date-fns/locale/tr").then((module) => module.tr);
        case Language.ro:
            return import("date-fns/locale/ro").then((module) => module.ro);
        case Language.en:
        default:
            return import("date-fns/locale/en-US").then((module) => module.enUS);
    }
}
